module.exports = require("@glimmer/tracking/primitives/cache");